module.exports = __webpack_public_path__ + "img/bhs_brandenburg_health_sciences.2bf42402.png";